/**
 * @fileoverview Captive carrier options for GEAO onboarding forms
 */

/**
 * @typedef {Object} CaptiveCarrierOption
 * @property {string} value - The string value representing the carrier choice
 * @property {string} label - The display label for the carrier option
 */

/**
 * Frozen array of captive carrier options for form selection components.
 * Used in GEAO onboarding forms where captive carrier choices need to be presented
 * as dropdown.
 * 
 * @type {ReadonlyArray<CaptiveCarrierOption>}
 * @constant
 * @default
 * 
 * @example
 * // Usage in a form component
 * import CaptiveCarrierOptions from './constants/options/CaptiveCarrierOptions';
 * 
 * const SelectField = () => (
 *   <select>
 *     {CaptiveCarrierOptions.map(option => (
 *       <option key={option.value} value={option.value}>
 *         {option.label}
 *       </option>
 *     ))}
 *   </select>
 * );
 */
export default Object.freeze([
    { value: "farm-bureau", label: "Farm Bureau" },
    { value: "farmers", label: "Farmers" },
    { value: "allstate", label: "Allstate" },
    { value: "geico", label: "GEICO" },
    { value: "state-farm", label: "State Farm" },
    { value: "other", label: "Other" }
]);